import script from "./company.vue?vue&type=script&setup=true&lang=ts"
export * from "./company.vue?vue&type=script&setup=true&lang=ts"

import "./company.vue?vue&type=style&index=0&id=ec3607a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec3607a8"]])

export default __exports__